import React, { useCallback, useMemo } from 'react';
import { CoreInputWithOptions } from './wut/WixUiCoreComponents/components/CoreInputWithOptons';
import { OptionFactory } from './wut/WixUiCoreComponents/components/CoreDropdownOption';
import { st, classes } from './autocomplete-wut.cssVars.st.css';
import { ChevronDown } from '@wix/wix-ui-icons-common/on-stage';
import { TextFieldTheme } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { useId } from '../../hooks/use-id';
import { useConfig } from '../../contexts/config-context';
const ARROW_DOWN = /*#__PURE__*/React.createElement("span", {
  className: classes.suffix
}, /*#__PURE__*/React.createElement(ChevronDown, {
  width: 24,
  height: 24,
  className: classes.arrowIcon
}));
const Prefix = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.prefix
  }, children);
};
export const createOption = option => OptionFactory.create(option);
export const AutocompleteWUT = _ref2 => {
  let {
    id,
    className,
    value,
    options,
    disabled,
    placeholder,
    error,
    showArrow,
    initialSelectedId,
    prefix,
    onInitialSelectedOptionsSet,
    filterPredicate,
    onSelect,
    onManualInput,
    onChange,
    onBlur,
    onFocus,
    ariaDescribedBy,
    theme = TextFieldTheme.Box
  } = _ref2;
  const {
    isRTL: rtl
  } = useConfig();
  const inputProps = useMemo(() => {
    return {
      id,
      value: value ?? '',
      error,
      placeholder,
      disabled,
      suffix: showArrow ? ARROW_DOWN : undefined,
      prefix: prefix ? /*#__PURE__*/React.createElement(Prefix, null, prefix) : undefined,
      onChange,
      onBlur,
      onFocus,
      'aria-autocomplete': 'both',
      'aria-describedby': ariaDescribedBy
    };
  }, [id, value, error, placeholder, disabled, showArrow, prefix, onChange, onBlur, onFocus, ariaDescribedBy]);
  const dropdownId = useId();
  const handleContentMouseDown = useCallback(e => {
    e.preventDefault(); // Prevent input blur from stopping click event
  }, []);
  const handleInitialSelectedOptionsSet = useCallback(selectedOptions => {
    onInitialSelectedOptionsSet == null || onInitialSelectedOptionsSet(selectedOptions[0]);
  }, [onInitialSelectedOptionsSet]);
  return /*#__PURE__*/React.createElement(CoreInputWithOptions, {
    id: dropdownId,
    className: st(classes.root, {
      disabled,
      error,
      hasPrefix: Boolean(prefix),
      hasSuffix: showArrow,
      rtl,
      theme
    }, classes.override, classNames(className, classes.theme, {
      [classes.rtl]: rtl
    })),
    inputProps: inputProps,
    options: options,
    initialSelectedIds: initialSelectedId ? [initialSelectedId] : undefined,
    onInitialSelectedOptionsSet: handleInitialSelectedOptionsSet,
    filterPredicate: filterPredicate,
    highlightMatches: false,
    allowReselect: true,
    onSelect: onSelect,
    onManualInput: onManualInput,
    onContentMouseDown: handleContentMouseDown
  });
};
//# sourceMappingURL=autocomplete-wut.js.map